import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import * as routes from '@routes';
import { BaseAuth, SEO } from '@components';
import { usePageStore } from '@stores';
import AuthLoginPage from './pages/auth/AuthLoginPage/AuthLoginPage';
import AuthActivationPage from './pages/auth/AuthActivationPage/AuthActivationPage';
import AuthResetPasswordPage from './pages/auth/AuthResetPasswordPage/AuthResetPasswordPage';

const AuthRoutes: React.FC = () => {
  const pageState = usePageStore();

  return (
    <BaseAuth>
      <SEO />
      <Routes>
        {!!pageState.getPage(routes.auth.LOGIN) && (
          <Route path={pageState.getChildPagePath(routes.auth.LOGIN, routes.auth.BASE)} element={<AuthLoginPage />} />
        )}
        {!!pageState.getPage(routes.auth.RESET_PASSWORD) && (
          <Route
            path={pageState.getChildPagePath(routes.auth.RESET_PASSWORD, routes.auth.BASE)}
            element={<AuthResetPasswordPage />}
          />
        )}
        {!!pageState.getPage(routes.auth.ACTIVATION) && (
          <Route
            path={pageState.getChildPagePath(routes.auth.ACTIVATION, routes.auth.BASE)}
            element={<AuthActivationPage />}
          />
        )}
        {!!pageState.getPage(routes.auth.LOGIN) && (
          <Route path="*" element={<Navigate to={pageState.getPagePath(routes.auth.LOGIN)} replace />} />
        )}
      </Routes>
    </BaseAuth>
  );
};

export default AuthRoutes;
